import styled from 'styled-components'
import { shimmerAnim } from '../../../utils'

const StyledLessonAbout = styled.div`
  padding: 25px 0;
  white-space: pre-wrap;
  line-height: 30px;
  color: ${({ theme }) => theme.color.gray[600]};

  p {
    &:not(:first-child) {
      margin-top: 20px;
    }
  }

  a {
    font-weight: 500;
    color: ${({ theme }) => theme.color.blue[600]};
  }

  .skel {
    display: grid;
    gap: 10px;

    div {
      height: 22px;
      max-width: 100%;
      border-radius: 6px;
      animation: ${shimmerAnim} 1.4s ease-in-out infinite;

      &:last-child {
        width: 67%;
      }
    }
  }
`

export default StyledLessonAbout
